import { Inject, inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IHiddenFromHomeAssignmentRequest } from '../../component/hidden-from-home-management-modal/hidden-from-home-management-modal.interface';
import { Observable } from 'rxjs';
import { GetManyResponseInterface } from '../../model/interface/crud-response-interface.model';
import { BulkResponse } from '../../model/interface/generic-api-response.model';

@Injectable({ providedIn: 'root' })
export class HideFromHomeTasksService {
  private readonly http = inject(HttpClient);

  constructor(@Inject('API_BASE_URL') private readonly api: string) {}

  public requestAssignment(dto: IHiddenFromHomeAssignmentRequest): Observable<GetManyResponseInterface<BulkResponse>> {
    return this.http.post<GetManyResponseInterface<BulkResponse>>(`${this.api}/hidden-from-home-tasks/assignment`, dto);
  }
}
